import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";
import api from "apis/webOrder";
import { 
  AgentInfo, 
  CommercialWebOrderResponse, 
  WebOrderStatusResponse, 
  WebOrderResponse, 
  WebOrderRequest, 
  CommercialWebOrderRequest, 
  WebOrderSettingsRequest, 
  WebOrderSettingsResponse,
} from "interfaces/Mueller.Business.Models";

export const addAttachment = (file, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.uploadFile(),
  successCallback,
  errorCallback,
  mountedRef,
  file
});

export const removeAttachment = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.removeFile(payload),
  successCallback,
  mountedRef
});

export const getSettings = (payload: WebOrderSettingsRequest, successCallback: (response: WebOrderSettingsResponse) => void, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.getSettings(),
  successCallback,
  mountedRef,
  payload
});

export const getBillingPreview = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.getBillingPreview(),
  successCallback,
  mountedRef,
  payload
});

export const submitWebOrder = (payload: WebOrderRequest, successCallback: (response: WebOrderResponse) => void, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.submitWebOrder(),
  successCallback,
  errorCallback,
  mountedRef,
  payload
});

export const submitCommercialWebOrder = (payload: CommercialWebOrderRequest, successCallback: (response: CommercialWebOrderResponse) => void, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/weborder/submit/commercial",
  successCallback,
  errorCallback,
  mountedRef,
  payload
});

export const getLenderAgencyCodes = (customerNumber: number, successCallback: (agents: AgentInfo[]) => void, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/weborder/lenders/${customerNumber}/agent-codes`,
  successCallback,
  mountedRef,
});

export const getInsuranceAgencyCodes = (customerNumber: number, successCallback: (agents: AgentInfo[]) => void, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/weborder/insurance/${customerNumber}/agent-codes`,
  successCallback,
  mountedRef,
});

export const getStatus = (importQueueAliasId: string, successCallback: (response: WebOrderStatusResponse) => void, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/weborder/status/${importQueueAliasId}`,
  successCallback,
  errorCallback,
  mountedRef,
});